import Vue from 'vue';
import Vuex, {StoreOptions} from 'vuex';
import { articleModule } from './modules/article/'
import {userInfoMock, deviceInfoMock} from '@/constants/mock';
import {isInApp} from '@/utils/mUtil';
import MgecApi from 'mgec-jssdk';
import RootState from './types';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const getUserInfo = () => {
  return new Promise((resolve, reject) => {
    if (location.href.indexOf('debugger') > -1) {
      return resolve(userInfoMock);
    }

    if (isInApp()) {
      MgecApi.callhandler('getUserInfo', {}, (data: object) => {
        resolve(data);
      });
    } else if (debug) {
      resolve(userInfoMock);
    } else {
      reject('MgecApi.getUserInfo error');
    }
  });
};

const getDeviceInfo = () => {
  return new Promise((resolve, reject) => {
    if (location.href.indexOf('debugger') > -1) {
      return resolve(deviceInfoMock);
    }
    if (isInApp()) {
      MgecApi.callhandler('getDeviceInfo', {}, (data: object) => {
        resolve(data);
      });
    } else if (debug) {
      resolve(deviceInfoMock);
    } else {
      reject('MgecApi.getDeviceInfo error');
    }
  });
};

const store: StoreOptions<RootState> = {
  state: {
    userInfo: null,
    deviceInfo: null,
  },
  getters: {
    isLogin(state) {
      const {userInfo} = state;
      return userInfo && Object.keys(userInfo).length > 0;
    },
  },
  mutations: {
    UpdateUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },

    addDeviceInfo(state, deviceInfo) {
      state.deviceInfo = deviceInfo;
    },
  },
  actions: {
    async autoLogin({commit}) {
      try {
        const deviceinfo: any = await getDeviceInfo();
        commit('addDeviceInfo', deviceinfo);

        const userinfo: any = await getUserInfo();
        if (!userinfo) return;
        commit('UpdateUserInfo', userinfo);
        console.log(userinfo);
        console.log(deviceinfo);
      } catch (error) {
        console.log(error);
      }
    },

    async login() {
      MgecApi.callhandler('login', {}, () => {
        location.reload();
      });
    },
  },
  modules: {
    articleModule
  },
};

export default new Vuex.Store<RootState>(store);
